import qs from 'qs'
// import axios from 'axios'
import { withHeadersInstance } from './api-instance.js'
const baseUrl = process.env.VUE_APP_URL_API

export const LogInService = async function(parameters) {
    try {
        if (parameters.email === undefined)
            return Promise.reject(
                new Error('Missing required  parameter: email')
            )
        if (parameters.password === undefined)
            return Promise.reject(
                new Error('Missing required  parameter: password')
            )

        return await withHeadersInstance({
            method: 'post',
            url: `${baseUrl}/login`,
            data: parameters,
        })
    } catch (e) {
        console.error(e)
        return e.response.data
    }
}

export const SendRecoveryEmail = async function(parameters) {
    try {
        if (parameters === undefined)
            return Promise.reject(
                new Error('Missing required  parameter: email')
            )
        return await withHeadersInstance({
            method: 'post',
            url: `${baseUrl}/forgot-password/${parameters}`,
        })
    } catch (e) {
        console.error(e)
        return e.response.data
    }
}

export const ResetPassword = async function(parameters) {
    try {
        const { email, code, password } = parameters
        if (email === undefined)
            return Promise.reject(
                new Error('Missing required  parameter: email')
            )
        if (code === undefined)
            return Promise.reject(
                new Error('Missing required  parameter: code')
            )
        if (password === undefined)
            return Promise.reject(
                new Error('Missing required  parameter: password')
            )
        return await withHeadersInstance({
            method: 'post',
            url: `${baseUrl}/reset-password`,
            data: parameters,
        })
    } catch (e) {
        console.error(e)
        return e.response
    }
}

export async function ChangePassword({ password, confirmPassword }) {
    try {
        if (typeof password === 'undefined')
            throw new Error('Missing required parameter: password')
        if (typeof confirmPassword === 'undefined')
            throw new Error('Missing required parameter: confirmPassword')
        return await withHeadersInstance({
            method: 'PUT',
            url: `${baseUrl}/change-password`,
            data: { password, confirmPassword },
        })
    } catch (e) {
        console.error(e)
        return e?.response
    }
}

export const GetLocations = async function(params) {
    try {
        const { email } = params
        const { parameters } = params
        const queryUrl = '?' + qs.stringify(parameters)
        if (email === undefined)
            return Promise.reject(
                new Error('Missing required  parameter: email')
            )
        return await withHeadersInstance({
            method: 'get',
            url: `${baseUrl}/locations/user/${email}${queryUrl}`,
        })
    } catch (e) {
        console.error(e)
        return e.response.data
    }
}

// export const GetUserPermissions = async function(locationPublicId) {
//     try {
//         if (locationPublicId === undefined)
//             return Promise.reject(
//                 new Error('Missing required  parameter: locationPublicId')
//             )
//         return await withHeadersInstance({
//             method: 'get',
//             url: `${baseUrl}/location/${locationPublicId}/permissions/allowed`,
//         })
//     } catch (e) {
//         console.error(e)
//         return e.response.data
//     }
// }

export const GetUserRoles = async function(parameters) {
    try {
        const { locationPublicId, userPublicId } = parameters
        if (locationPublicId === undefined)
            return Promise.reject(
                new Error('Missing required  parameter: locationPublicId')
            )
        if (userPublicId === undefined)
            return Promise.reject(
                new Error('Missing required  parameter: userPublicId')
            )
        return await withHeadersInstance({
            method: 'get',
            url: `${baseUrl}/location/${locationPublicId}/user/${userPublicId}`,
        })
    } catch (e) {
        console.error(e)
        return e.response.data
    }
}

export const SavePicture = async function(parameters) {
    try {
        return await withHeadersInstance({
            method: 'post',
            url: `${baseUrl}/user-profile/picture`,
            data: parameters,
        })
    } catch (e) {
        console.error(e)
    }
}

export const DeletePicture = async function() {
    try {
        return await withHeadersInstance({
            method: 'delete',
            url: `${baseUrl}/user-profile/picture`,
        })
    } catch (e) {
        console.error(e)
    }
}

export const NewToken = async function(parameters) {
    try {
        return await withHeadersInstance({
            method: 'post',
            url: `${baseUrl}/refresh`,
            data: parameters,
        })
    } catch (e) {
        console.error(e)
    }
}
